module.exports = __webpack_public_path__ + "VIPV27.png?ec5c18f035f79846314e58ada0a4de76";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPV27.png
// module id = 122
// module chunks = 0